module.exports = __webpack_public_path__ + "img/mg-papelaria-square.e2c7cc56.jpg";